import Vue from 'vue';
import VueGeolocationApi from 'vue-geolocation-api';

Vue.use(VueGeolocationApi /*, { ...options } */);
